// ** React Imports
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'

// ** Custom Components
import Avatar from '@components/avatar'
import { useTranslation } from 'react-i18next'

// ** Utils
import { isUserLoggedIn } from '@utils'

// ** Store & Actions
import { useDispatch } from 'react-redux'
import { handleLogout } from '@store/authentication'

// ** Third Party Components
import { User, Power } from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'

// ** Default Avatar Image
//import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-11.jpg'
import defaultAvatar from '@src/assets/images/avatars/avatar_light.png'

const UserDropdown = () => {
  // ** Store Vars
  const dispatch = useDispatch()

  // ** Translate
  const { t } = useTranslation()

  // ** State
  const [userData, setUserData] = useState(null)
  const [ppLoaded, setPPLoaded] = useState(false)

  async function checkAccessToken() {
    let baseUrl = 'https://auth.dev.optimahr.dev'
    if (document.location.hostname.endsWith('optimahr.app')) baseUrl = `https://auth.optimahr.app`
//    baseUrl = 'http://localhost:8004'
    
      fetch(`${baseUrl}/token`, {
          headers: {
            Authorization: "Bearer ".concat(JSON.parse(localStorage.getItem("accessToken"))),
            'x-refresh-token': JSON.parse(localStorage.getItem("refreshToken")),
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      ).then((response) => {
        if (response.status === 201) {
          // Created
          const tokens = response.json()
          localStorage.setItem("accessToken", `"${  tokens.accessToken  }"`)
          localStorage.setItem("refreshToken", `"${  tokens.refreshToken  }"`)
      } else if (response.status !== 304) {
          console.log("Logout")
          localStorage.setItem("logout", true)
          parent.location.reload(true)
      }
      })
  }

  async function getProfilePicture() {
    checkAccessToken()
    let baseUrl = 'https://auth.dev.optimahr.dev'
    if (document.location.hostname.endsWith('optimahr.app')) baseUrl = `https://auth.optimahr.app`
//    baseUrl = 'http://localhost:8004'

    await fetch(`${baseUrl}/me/profile-picture`, {
        headers: {
          Authorization: "Bearer ".concat(JSON.parse(localStorage.getItem("accessToken"))),
          'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then((response) => response.text()).then((data) => {
      localStorage.setItem("avatar", data)
      setPPLoaded(true)
    })
}

  //** ComponentDidMount
  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))

      getProfilePicture()
    }
  }, [])

  let userAvatar = localStorage.getItem("avatar") || defaultAvatar

  useEffect(() => {
    userAvatar = localStorage.getItem("avatar")
  }, [ppLoaded])

  useEffect(() => {
    const avatarListener = () => {
      userAvatar = localStorage.getItem("avatar")
    }
    window.addEventListener("storage", avatarListener)

    return () => {
      window.removeEventListener("storage", avatarListener)
    }
  })

  //** Vars
//  const userAvatar = (userData && userData.avatar) || defaultAvatar

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
        <span className='user-name fw-bold'>{(userData && userData['firstname']) || 'John Doe'}</span>
        <span className='user-name fw-bold'>{(userData && userData['lastname']) || 'John Doe'}</span>
        </div>
        <Avatar img={userAvatar} imgHeight='40' imgWidth='40'  />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to='/pages/account-settings'>
          <User size={14} className='me-75' />
          <span className='align-middle'>{t("Profile")}</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/login' onClick={() => dispatch(handleLogout())}>
          <Power size={14} className='me-75' />
          <span className='align-middle'>{t("Logout")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
